import * as React from 'react';
import { cn } from '../../lib/cn';

const TwCard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'rounded-lg border border-border bg-surface text-primary-900 shadow-soft',
      className
    )}
    {...props}
  />
));
TwCard.displayName = 'TwCard';

const TwCardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('flex flex-col space-y-1.5 p-6', className)} {...props} />
));
TwCardHeader.displayName = 'TwCardHeader';

const TwCardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3 ref={ref} className={cn('text-2xl font-semibold leading-none tracking-tight', className)} {...props} />
));
TwCardTitle.displayName = 'TwCardTitle';

const TwCardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('p-6 pt-0', className)} {...props} />
));
TwCardContent.displayName = 'TwCardContent';

export { TwCard, TwCardHeader, TwCardTitle, TwCardContent };
